import { Directive, HostListener, Input, inject } from '@angular/core';

import { DialogRef } from './dialog-ref';

@Directive({
  selector: '[dialogClose], dialogClose',
  standalone: true,
})
export class DialogCloseDirective<T = any> {
  private dialogRef = inject<DialogRef<T>>(DialogRef, { optional: true });

  @Input('dialogClose') dialogResult: T;

  @HostListener('click') public onClick(): void {
    if (!this.dialogRef) {
      console.error('dialogClose is not supported within a template');

      return;
    }

    if (this.dialogRef.config?.closeWithFalse) {
      this.dialogRef.close(false as T);
    } else {
      this.dialogRef.close(this.dialogResult);
    }
  }
}
